import { render, staticRenderFns } from "./dbTableList.vue?vue&type=template&id=177aefc8&scoped=true&"
import script from "./dbTableList.vue?vue&type=script&lang=js&"
export * from "./dbTableList.vue?vue&type=script&lang=js&"
import style0 from "./dbTableList.vue?vue&type=style&index=0&id=177aefc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177aefc8",
  null
  
)

export default component.exports